import { useForm } from '@/common/form/FormContext';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// Whether the summary's columns are products or periods
export const DemGtnSummaryModeToggle = () => {
  const { formValues, assignValue } = useForm();

  return (
    <ToggleButtonGroup
      exclusive
      value={formValues.mode}
      onChange={(event, mode) => mode && assignValue('mode', mode)}
      sx={{ height: 40 }}
    >
      <ToggleButton value="PROD" sx={{ px: 1.5, py: 0.25 }}>
        Products
      </ToggleButton>
      <ToggleButton value="PERIOD" sx={{ px: 1.5, py: 0.25 }}>
        Periods
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
